module.exports = __webpack_public_path__ + "static/media/che-fare.a75ba89c.png";